const CARDS = [
  { label: 'Intent',    color: '#0d3a6e', accent: '#0099cc' },
  { label: 'Execute',   color: '#0a3558', accent: '#00b4d8' },
  { label: 'Evidence',  color: '#083050', accent: '#00c8a0' },
  { label: 'Review',    color: '#0b3560', accent: '#00aacc' },
  { label: 'Govern',    color: '#0d3a6e', accent: '#0088bb' },
  { label: 'Improve',   color: '#083c6e', accent: '#00c4e8' },
];

export function CardTileTransit() {
  return (
    <div className="ctt-container">
      <style>{`
        .ctt-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          min-height: 340px;
          perspective: 700px;
          overflow: hidden;
        }

        .ctt-scene {
          position: relative;
          width: 180px;
          height: 240px;
          transform-style: preserve-3d;
        }

        .ctt-card {
          position: absolute;
          inset: 0;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transform-origin: bottom center;
          transform-style: preserve-3d;
          backface-visibility: hidden;
        }

        .ctt-card-inner {
          width: 100%;
          height: 100%;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          border: 1px solid rgba(255,255,255,0.1);
          backdrop-filter: blur(8px);
          box-shadow:
            0 4px 20px rgba(0,0,0,0.4),
            inset 0 1px 0 rgba(255,255,255,0.07);
        }

        .ctt-card-label {
          letter-spacing: 0.12em;
          text-transform: uppercase;
          font-size: 13px;
          font-weight: 600;
        }

        .ctt-card-bar {
          width: 40px;
          height: 2px;
          border-radius: 2px;
          opacity: 0.6;
        }

        .ctt-card-0 { animation: ctt-cardCycle 12s cubic-bezier(0.4,0,0.2,1) infinite 0s; }
        .ctt-card-1 { animation: ctt-cardCycle 12s cubic-bezier(0.4,0,0.2,1) infinite 2s; }
        .ctt-card-2 { animation: ctt-cardCycle 12s cubic-bezier(0.4,0,0.2,1) infinite 4s; }
        .ctt-card-3 { animation: ctt-cardCycle 12s cubic-bezier(0.4,0,0.2,1) infinite 6s; }
        .ctt-card-4 { animation: ctt-cardCycle 12s cubic-bezier(0.4,0,0.2,1) infinite 8s; }
        .ctt-card-5 { animation: ctt-cardCycle 12s cubic-bezier(0.4,0,0.2,1) infinite 10s; }

        @keyframes ctt-cardCycle {
          0% {
            transform: translateZ(0px) rotateX(0deg);
            opacity: 1;
            z-index: 6;
          }
          15% {
            transform: translateZ(120px) rotateX(-15deg);
            opacity: 1;
            z-index: 6;
          }
          30% {
            transform: translateZ(600px) rotateX(-90deg);
            opacity: 0;
            z-index: 1;
          }
          31% {
            transform: translateZ(-80px) rotateX(20deg);
            opacity: 0;
            z-index: 1;
          }
          45% {
            transform: translateZ(-40px) rotateX(10deg);
            opacity: 0.5;
            z-index: 2;
          }
          60% {
            transform: translateZ(0px) rotateX(0deg);
            opacity: 1;
            z-index: 5;
          }
          100% {
            transform: translateZ(0px) rotateX(0deg);
            opacity: 1;
            z-index: 5;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .ctt-card-0, .ctt-card-1, .ctt-card-2, .ctt-card-3, .ctt-card-4, .ctt-card-5 {
            animation: none;
          }
        }
      `}</style>

      <div className="ctt-scene">
        {CARDS.map((card, i) => (
          <div key={card.label} className={`ctt-card ctt-card-${i}`}>
            <div
              className="ctt-card-inner"
              style={{ background: `linear-gradient(160deg, ${card.color}cc 0%, #060c20cc 100%)` }}
            >
              <div className="ctt-card-bar" style={{ background: card.accent }} />
              <span className="ctt-card-label" style={{ color: card.accent }}>
                {card.label}
              </span>
              <div className="ctt-card-bar" style={{ background: card.accent }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
